var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "calendar_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 42,
    height: 39,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11V2M35 11V2M3 17h42M9 31h30M18 23v16M30 23v16"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+Y2FsZW5kYXIgZGF0ZSAyPC90aXRsZT48ZyBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMjcyNzI2IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibmMtaWNvbi13cmFwcGVyIj48cmVjdCB4PSIzIiB5PSI2IiB3aWR0aD0iNDIiIGhlaWdodD0iMzkiIHJ4PSI0Ij48L3JlY3Q+PGxpbmUgeDE9IjEzIiB5MT0iMTEiIHgyPSIxMyIgeTI9IjIiPjwvbGluZT48bGluZSB4MT0iMzUiIHkxPSIxMSIgeDI9IjM1IiB5Mj0iMiI+PC9saW5lPjxsaW5lIHgxPSIzIiB5MT0iMTciIHgyPSI0NSIgeTI9IjE3Ij48L2xpbmU+PGxpbmUgeDE9IjkiIHkxPSIzMSIgeDI9IjM5IiB5Mj0iMzEiIHN0cm9rZT0iIzI3MjcyNiI+PC9saW5lPjxsaW5lIHgxPSIxOCIgeTE9IjIzIiB4Mj0iMTgiIHkyPSIzOSIgc3Ryb2tlPSIjMjcyNzI2Ij48L2xpbmU+PGxpbmUgeDE9IjMwIiB5MT0iMjMiIHgyPSIzMCIgeTI9IjM5IiBzdHJva2U9IiMyNzI3MjYiPjwvbGluZT48L2c+PC9zdmc+";
export { SvgCalendar as ReactComponent };